@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.spanClass {
  display: flex;
  align-items: center;
  text-align: center;
  min-width: 96%;
  justify-content: flex-start;
  padding-left: 8px;
  padding-right: 8px;
  gap: 6px;
}

.popoverClass {
  max-height: 210px;
  overflow-y: scroll;
}

.svgSpan {
  display: flex;
  align-items: center;
  justify-content: center;
}
